import { useQuery } from "@tanstack/react-query";

import {
  auditLogService,
  type AuditLogFilters,
} from "~/services/contabilidad/auditLogService";

export const AUDIT_LOG_QUERY_KEY = ["audit-log"];

export function useAuditLog(filters?: AuditLogFilters) {
  return useQuery({
    queryKey: [...AUDIT_LOG_QUERY_KEY, filters],
    queryFn: () => auditLogService.getAll(filters),
  });
}
